import React from 'react'
import HeaderOne from "../components/header/HeaderOne";
import BannerFive from "../components/banner/BannerFive";
import AboutOne from "../components/about/AboutOne";
import ServiceOne from "../components/service/ServiceOne";
import BusinessGoalOne from "../components/businessgoal/BusinessGoalOne";
import Counterup from "../components/counterup/Counterup";
import GalleryOne from "../components/gallery/GalleryOne";
import BrandOne from "../components/brand/BrandOne";
import TeamOne from "../components/team/TeamOne";
import Feature from "../components/feature/Feature";
import TestimonialOne from "../components/testimonials/TestimonialOne";
import BlogThree from "../components/blog/BlogThree";
import ContactForm from "../components/contactform/ContactForm";
import MapOne from "../components/map/MapOne";




import FooterFour from '../components/footer/FooterFour';

function HomeOne() {
  return (
    <div>

      <HeaderOne />
      <BannerFive />
      <AboutOne />
      <ServiceOne />
      <BusinessGoalOne />
      <Counterup />

      <GalleryOne />
      <BrandOne />
      <TeamOne />
      <Feature />
      <TestimonialOne />
      <BlogThree />
      <ContactForm />
      <MapOne />




      <FooterFour />

    </div>
  )
}

export default HomeOne